<div class="content" data-qa="dashboard" fxLayout="column">

    <h2 data-qa="tnb-sub-header">Dashboard</h2>

    @if (dashboardInfoStatus() === 'PENDING') {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (isAdmin && dashboardInfoStatus() === 'SUCCESS') {
        <div class="flex-wrap">
            <div fxLayout="column" fxLayoutGap="2rem" fxFlex="1 1 auto">
                <redispatch-dashboard-netzzuordnungen-import
                    [netzzuordungImport]="dashboardInfo().netzzuordungImport"
                    data-qa="netzzuordnungen-kachel">
                </redispatch-dashboard-netzzuordnungen-import>

                <div>
                    <redispatch-dashboard-dienstleistungsarten [dienstleistungsarten]="dashboardInfo().dienstleistungsarten">
                    </redispatch-dashboard-dienstleistungsarten>
                </div>

            </div>
            <div fxLayout="column" fxLayoutGap="2rem" fxFlex="1 1 auto">
                <redispatch-dashboard-unbestaetigte-uuids [unbestaetigteUuids]="dashboardInfo().unbestaetigteUuids">
                </redispatch-dashboard-unbestaetigte-uuids>
            </div>
        </div>
    }


    @if (isStadtwerk && dashboardInfoStatus() === 'SUCCESS' && dashboardInfo(); as snapshot) {
        <div class="flex-wrap">
            @if (snapshot.erzeugungsanlage) {
                <div fxLayout="column">
                    <h3>Datenaktualisierung</h3>
                    <mat-card fxFlex>
                        <mat-card-content>
                            <redispatch-dashboard-datenaktualisierung
                                [lastUpdated]="snapshot.erzeugungsanlage.lastUpdate"></redispatch-dashboard-datenaktualisierung>
                        </mat-card-content>
                    </mat-card>
                </div>
            }
            @if (snapshot.planwerte) {
                <div fxLayout="column" data-qa="hinweis-planwert">
                    <h3>Hinweis zu Planwerten</h3>
                    <mat-card fxFlex>
                        <mat-card-content>
                            <redispatch-dashboard-planwerte
                                [invalidPlanwerteAvailable]="snapshot.planwerte.hasInvalidPlanwerte"
                                [stadtwerkeId]="selectedStadtwerkId"
                                [planwertFilter]="getPlanwerteFilter()"
                            ></redispatch-dashboard-planwerte>
                        </mat-card-content>
                    </mat-card>
                </div>
            }
        </div>
    }

    @if (dashboardInfo().erzeugungsanlage && dashboardInfo().planwerte && dashboardInfo().netzzuordnung && dashboardInfo(); as snapshot) {
        <div class="flex-wrap">
            <div data-qa="bedienungsanleitung" fxLayout="column">
                <h3>Bedienungsanleitung</h3>
                <mat-card fxLayout="column" fxLayoutAlign="center" fxFlex>
                    <mat-card-content>
                        <redispatch-dashboard-bedienungsanleitung></redispatch-dashboard-bedienungsanleitung>
                    </mat-card-content>
                </mat-card>
            </div>

            <div fxLayout="column">
                <h3>Hinweis zu Netzzuordnungen</h3>
                <div fxLayout="column" fxLayoutGap="1rem" fxFlex>
                    <mat-card data-qa="hinweis-netzzuordnungen" fxFlex>
                        <mat-card-content>
                            <redispatch-dashboard-netzzuordnungen
                                [invalidNetzzuordnungen]="snapshot.erzeugungsanlage.amountWithInvalidNetzzuordnung"
                            ></redispatch-dashboard-netzzuordnungen>
                        </mat-card-content>
                    </mat-card>
                    <mat-card data-qa="hinweis-uuid-confirmation" fxFlex>
                        <mat-card-content>
                            <redispatch-dashboard-uuid-change-confirmation
                                [snapshot]="snapshot.netzzuordnung"
                            ></redispatch-dashboard-uuid-change-confirmation>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    }
</div>
